import {
  emotionStyled,
  tokens,
  mobileTextControlStyleAtom,
} from '@packages/utilities/styled';

import {
  disabledSelector,
  errorSelector,
  hoverSelector,
  nonErrorFocusedSelector,
} from '../../utils';

export const TextareaWrapperView = emotionStyled('div')(
  {
    alignItems: 'flex-start',
    backgroundColor: `$uiInputBackground`,
    border: '1px solid',
    borderColor: '$uiInputBorderColor',
    borderRadius: '$2',
    boxShadow: '$inputInner',
    color: '$textPrimary',
    display: 'flex',
    position: 'relative',
    width: '100%',
    [disabledSelector('&')]: {
      backgroundColor: '$backgroundInactive',
      borderColor: '$border3',
      cursor: 'not-allowed',
      opacity: tokens.opacities.disabled,
    },
    [`&${errorSelector}`]: {
      borderColor: '$redBorder',
    },
    [`&${hoverSelector}`]: {
      borderColor: '$uiInputBorderColorHover',
    },
    [`&${nonErrorFocusedSelector}`]: {
      borderColor: '$blueBorder',
      outline: 'none',
    },
  },
  {
    componentName: 'TextareaWrapper',
  }
);

export const TextareaView = emotionStyled('textarea')(
  {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: '$textPrimary',
    display: 'block',
    flex: 1,
    fontFamily: '$sansSerif',
    fontSize: '$body',
    // Disables the Inter font's `liga` and `calt` features so values like
    // `1920x1080` render literally (see CONT-6296). The shipped Inter build
    // defines this substitution under `liga`; newer builds use `calt`.
    fontVariantLigatures: 'no-common-ligatures no-contextual',
    height: '100%',
    outline: 'none',
    padding: '$2',
    position: 'relative',
    resize: 'none',
    width: '100%',
    ':-webkit-autofill': {
      // These properties are necessary to make the user agent styles for autofill disappear (like turning the input background yellow and changing the text color)
      backgroundClip: 'text',
      WebkitTextFillColor: tokens.colors.textPrimary,
      caretColor: tokens.colors.textPrimary,
    },
    '&::placeholder': {
      color: '$textDimmed',
    },

    [`${TextareaWrapperView}[data-disabled="true"] &`]: {
      color: '$textPrimary',
      cursor: 'not-allowed',
      '&::placeholder': {
        color: '$textPrimary',
      },
    },
  },
  {
    componentName: 'Textarea',
    variants: {
      resize: {
        both: {
          resize: 'both',
        },
        horizontal: {
          resize: 'horizontal',
        },
        none: {
          resize: 'none',
        },
        vertical: {
          resize: 'vertical',
        },
      },
      shouldAutoSize: {
        true: {
          resize: 'none',
        },
      },
      fontFamily: {
        sansSerif: {fontFamily: '$sansSerif'},
        mono: {fontFamily: '$mono'},
      },
    },
    composes: [mobileTextControlStyleAtom],
  }
);

export const TextareaPrefixWrapper = emotionStyled('div')({
  display: 'flex',
  height: 'auto',
  paddingTop: '$2',
  paddingBottom: '$2',
  paddingLeft: '$2',
});

export const TextareaSuffixWrapper = emotionStyled('div')({
  display: 'flex',
  height: 'auto',
  paddingTop: '$2',
  paddingBottom: '$2',
  paddingRight: '$2',
});

export const TextareaContentView = emotionStyled('div')({
  display: 'flex',
  gap: tokens.space[0.5],
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
});

export const TextareaPrefixSuffixView = emotionStyled('div')({
  display: 'flex',
  fontSize: '$body',
  height: '100%',
  position: 'relative',
});
